import React from "react";
import DMModuleSubtopic from "../DMModuleSubtopic";

const RecurrenceRelation = () => (
  <DMModuleSubtopic
    title="Recurrence relation"
    videos={[
      "https://www.youtube.com/embed/DdpmzBE-LOE?list=PLXj4XH7LcRfBB-4hXp4XI84HOCWkaBD63",
      "https://www.youtube.com/embed/a1pmfQt1Gn0?list=PLXj4XH7LcRfBB-4hXp4XI84HOCWkaBD63",
      "https://www.youtube.com/embed/cPDDWzwRsGU?list=PLXj4XH7LcRfBB-4hXp4XI84HOCWkaBD63",
      "https://www.youtube.com/embed/vqrv_mVqCnY",
      "https://www.youtube.com/embed/k_lXL5w5NiI"

    ]}
    takeaways={[
        {text:"for Non-Homogeneous",
         image:"/dm_15.png"
        }
    ]}
    questions={[
        {
            text:"Solve the following recurrence equation",
            image:"/dm_16.png"
        },
        {image:"/dm_17.png"},
        {image:"/dm_18.png"},
        {image:"/dm_19.png"}
        
        
    ]}
    exampleVideos={[]}
  />
);

export default RecurrenceRelation;
